export default "__VITE_ASSET__27b53a1b__"